import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-vip',
  templateUrl: './portal-vip.component.html',
  styleUrls: ['./portal-vip.component.scss']
})
export class PortalVipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
